import { Box, Divider, Flex, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { CustomInput } from '../CustomInput';

const safeParseNumber = (value: string | undefined | null): number => {
  if (!value || value.toString().trim() === '') return 0;
  const parsed = parseInt(value.toString(), 10);
  return isNaN(parsed) ? 0 : parsed;
};

export const RobeSizes = ({
  onSelectionChange,
  values,
  isDisabled,
  label,
}: {
  onSelectionChange?: (sizes: any) => void;
  values?: any;
  isDisabled?: boolean;
  label?: string;
}) => {
  const [sizes, setSizes]: [any, (sizes: any) => void] = useState<any>(
    values || {
      xs: '',
      s: '',
      m: '',
      l: '',
      xl: '',
      classMasterXS: '',
      classMasterS: '',
      classMasterM: '',
      classMasterL: '',
      classMasterXL: '',
    }
  );

  const handleChange = (key: string, value: string) => {
    if (
      value === '' ||
      (!isNaN(Number(value)) &&
        Number.isInteger(Number(value)) &&
        Number(value) >= 0)
    ) {
      setSizes({ ...sizes, [key]: value });
    }
  };

  useEffect(() => {
    onSelectionChange?.(sizes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sizes]);

  return (
    <Box>
      <Text mb="xs" fz="sm" fw={500}>
        {label}
      </Text>
      <Box style={{ textAlign: 'center' }}>
        <Flex align="center" gap={4}>
          <Box style={{ width: '25%' }}>
            <Text size="xs">Înălțimea absolventului</Text>
          </Box>
          <Box style={{ width: '15%' }}>
            <Text size="xs">sub 1.66m</Text>
          </Box>
          <Box style={{ width: '15%' }}>
            <Text size="xs">
              între <br />
              1.67m și 1.71m
            </Text>
          </Box>
          <Box style={{ width: '15%' }}>
            <Text size="xs">
              între <br />
              1.72m și 1.80m
            </Text>
          </Box>
          <Box style={{ width: '15%' }}>
            <Text size="xs">
              între <br />
              1.81m și 1.85m
            </Text>
          </Box>
          <Box style={{ width: '15%' }}>
            <Text size="xs">peste 1.85m</Text>
          </Box>
        </Flex>

        <Divider my="xs" />

        <Flex align="center" gap={4}>
          <Box style={{ width: '25%' }}>
            <Text size="xs">Mărimea robei recomandată</Text>
          </Box>
          <Box style={{ width: '15%' }}>
            <Text size="sm" fw={700}>
              XS
            </Text>
          </Box>
          <Box style={{ width: '15%' }}>
            <Text size="sm" fw={700}>
              S
            </Text>
          </Box>
          <Box style={{ width: '15%' }}>
            <Text size="sm" fw={700}>
              M
            </Text>
          </Box>
          <Box style={{ width: '15%' }}>
            <Text size="sm" fw={700}>
              L
            </Text>
          </Box>
          <Box style={{ width: '15%' }}>
            <Text size="sm" fw={700}>
              XL
            </Text>
          </Box>
        </Flex>

        <Divider my="xs" />

        <Flex align="center" gap={4}>
          <Box style={{ width: '25%' }}>
            <Text size="xs">Necesar robe pentru absolvenți</Text>
          </Box>
          <Box style={{ width: '15%' }}>
            <CustomInput
              value={sizes.xs || ''}
              name="xs"
              type="number"
              minValue={0}
              onChange={(value) => handleChange('xs', value?.toString() || '')}
              isDisabled={isDisabled}
            />
          </Box>
          <Box style={{ width: '15%' }}>
            <CustomInput
              value={sizes.s || ''}
              name="s"
              type="number"
              minValue={0}
              onChange={(value) => handleChange('s', value?.toString() || '')}
              isDisabled={isDisabled}
            />
          </Box>
          <Box style={{ width: '15%' }}>
            <CustomInput
              value={sizes.m || ''}
              name="m"
              type="number"
              minValue={0}
              onChange={(value) => handleChange('m', value?.toString() || '')}
              isDisabled={isDisabled}
            />
          </Box>
          <Box style={{ width: '15%' }}>
            <CustomInput
              value={sizes.l || ''}
              name="l"
              type="number"
              minValue={0}
              onChange={(value) => handleChange('l', value?.toString() || '')}
              isDisabled={isDisabled}
            />
          </Box>
          <Box style={{ width: '15%' }}>
            <CustomInput
              value={sizes.xl || ''}
              name="xl"
              type="number"
              minValue={0}
              onChange={(value) => handleChange('xl', value?.toString() || '')}
              isDisabled={isDisabled}
            />
          </Box>
        </Flex>

        <Divider my="xs" />

        <Flex align="center" gap={4}>
          <Box style={{ width: '25%' }}>
            <Text size="xs">Măsură robă diriginte</Text>
          </Box>
          <Box style={{ width: '15%' }}>
            <CustomInput
              value={sizes.classMasterXS || ''}
              name="classMasterXS"
              type="number"
              minValue={0}
              onChange={(value) =>
                handleChange('classMasterXS', value?.toString() || '')
              }
              isDisabled={isDisabled}
            />
          </Box>
          <Box style={{ width: '15%' }}>
            <CustomInput
              value={sizes.classMasterS || ''}
              name="classMasterS"
              type="number"
              minValue={0}
              onChange={(value) =>
                handleChange('classMasterS', value?.toString() || '')
              }
              isDisabled={isDisabled}
            />
          </Box>
          <Box style={{ width: '15%' }}>
            <CustomInput
              value={sizes.classMasterM || ''}
              name="classMasterM"
              type="number"
              minValue={0}
              onChange={(value) =>
                handleChange('classMasterM', value?.toString() || '')
              }
              isDisabled={isDisabled}
            />
          </Box>
          <Box style={{ width: '15%' }}>
            <CustomInput
              value={sizes.classMasterL || ''}
              name="classMasterL"
              type="number"
              minValue={0}
              onChange={(value) =>
                handleChange('classMasterL', value?.toString() || '')
              }
              isDisabled={isDisabled}
            />
          </Box>
          <Box style={{ width: '15%' }}>
            <CustomInput
              value={sizes.classMasterXL || ''}
              name="classMasterXL"
              type="number"
              minValue={0}
              onChange={(value) =>
                handleChange('classMasterXL', value?.toString() || '')
              }
              isDisabled={isDisabled}
            />
          </Box>
        </Flex>

        <Flex justify="space-between" mt="md">
          <Text size="xs">Total necesar robe (elevi + diriginte)</Text>
          <Text size="xs" fw={700}>
            {Object.values(sizes).reduce(
              (acc: number, curr: any) => acc + safeParseNumber(curr),
              0
            )}
          </Text>
        </Flex>
      </Box>
    </Box>
  );
};
